import { useState } from 'react'

import moment from 'utils/moment'
import Styled from './styled'
import './style.css'
import Chart from '../GanttChart/index'
import { useAsync } from 'react-use'
import { UpOutlined, DownOutlined } from '@ant-design/icons'
import { getIncidentApi } from 'services/incident'
import FilterRiskOwnerSelect from 'components/FilterRiskOwnerSelect'

import { useTranslate } from 'hooks/translate'

import { useStoreActions, useStoreState } from 'easy-peasy'

import FilterReportStatusSelect from 'components/FilterReportStatusSelect'
import FilterReportTypeSelect from 'components/FilterReportTypeSelect'
import FilterTaskStatusSelect from 'components/FilterTaskStatusSelect'
import SearchOrganization from 'components/SearchOrganization'

import { Row, Col, Form, Button, DatePicker, Pagination, Card, Input } from 'antd'

const { RangePicker } = DatePicker

const DATE_FORMAT = 'YYYY-MM-DD'
const DEFAULT_PAGE_SIZE = 10

export default function PageActionplan () {
  const { loading, monthlyReviewFilters, monthlyReviewList } = useStoreState(
    (store) => store.monthlyDashboard
  )

  const {
    getMonthlyReviewThunk,
    setMonthlyReviewFilters,
    setIcPeriodFilters,
    setIcDateFilters,
    setIcReportTypeNumberFilters,
    setIcRemoveIncidentFilters,
  } = useStoreActions((store) => store.monthlyDashboard)

  const [dataSource, setDataSource] = useState({ items: [] })
  const [totalPage, setTotalPage] = useState(10)
  const [hideContent, setHideContent] = useState(true)
  const [showHeader, setShowHeader] = useState(true)

  const { t } = useTranslate()

  const [filters, setFilters] = useState({
    incident_topic: null,
    reporter: null,
    risk_co: null,
    risk_owner_org: null,
    date_from: moment()
      .startOf('year')
      .format(DATE_FORMAT),
    date_to: moment().format(DATE_FORMAT),
    report_status_id: null,
    report_type_id: null,
    task_status_id: null,
    page: 1,
    size: DEFAULT_PAGE_SIZE,
    param: null,
    has_task: true,
  })

  const handleSubmit = (event) => {
    setFilters({
      ...filters,
      incident_topic: event.incident_topic,
    })
    setHideContent(false)
    getIncident()
    clearSelector()
  }

  const clearSelector = () => {
    setIcDateFilters([])
    setIcPeriodFilters('monthly')
    setIcReportTypeNumberFilters([])
    setIcRemoveIncidentFilters([])
  }

  const getIncident = async () => {
    const res = await getIncidentApi(filters)
    setDataSource(res?.data)
    setTotalPage(res?.data?.total)
  }

  useAsync(async () => {
    // getIncident()
  }, [])

  return (
    <Styled className='page page-monthly-review'>
      {showHeader ? (
        <Form
          layout='horizontal'
          colon={false}
          initialValues={{
            date_from: [
              filters?.date_from ? moment(filters?.date_from) : moment().startOf('year'),
              filters?.date_to ? moment(filters?.date_to) : moment(),
            ],
          }}
          name='search'
          onFinish={handleSubmit}
        >
          <Row gutter={8}>
            <Col span={22}>
              <Row gutter={8}>
                <Col span={24}>
                  <Form.Item name='incident_topic' label='Incident Topic'>
                    <Input
                      placeholder='Incident Topic'
                      id='input_incident_topic'
                      onChange={(event) => {
                        let str = document.getElementById('input_incident_topic').value
                        setFilters({
                          ...filters,
                          incident_topic: str,
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={8}>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <Form.Item name='reporter' label='Reporter'>
                    <SearchOrganization
                      onChange={(value) => {
                        setFilters({
                          ...filters,
                          reporter: value,
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <Form.Item name='risk_co' label='Risk Co'>
                    <SearchOrganization
                      onChange={(value) => {
                        setFilters({
                          ...filters,
                          start: value,
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={8}>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <Form.Item name='risk_owner' label='Risk Owner'>
                    <FilterRiskOwnerSelect
                      onChange={(value) => {
                        setFilters({
                          ...filters,
                          risk_owner_org: value,
                        })
                      }}
                    />
                    {/* <SearchOrganization 
                      onChange={(value)=>{
                        setFilters({
                          ...filters,
                          risk_owner: value
                        })
                      }}
                    /> */}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8}>
                  <Form.Item name='date_from' label='Report From - to'>
                    <RangePicker
                      allowClear={false}
                      format={DATE_FORMAT}
                      style={{ width: '100%' }}
                      onChange={(value) => {
                        setFilters({
                          ...filters,
                          date_from: value[0].format(DATE_FORMAT),
                          date_to: value[1].format(DATE_FORMAT),
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={8}>
                <Col xs={24} sm={24} md={24} lg={8}>
                  <Form.Item name='report_type_id' label='Report Type'>
                    <FilterReportTypeSelect
                      att={{ mode: 'multiple' }}
                      onChange={(value) => {
                        setFilters({
                          ...filters,
                          report_type_id: value,
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8}>
                  <Form.Item name='report_status_id' label='Report  Status'>
                    <FilterReportStatusSelect
                      att={{ mode: 'multiple' }}
                      onChange={(value) => {
                        setFilters({
                          ...filters,
                          report_status_id: value,
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8}>
                  <Form.Item name='task_status_id' label='Task Status'>
                    <FilterTaskStatusSelect
                      att={{ mode: 'multiple' }}
                      onChange={(value) => {
                        setFilters({
                          ...filters,
                          task_status_id: value,
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={24} md={24} lg={2}>
              <Button type='primary' htmlType='submit'>
                {t('Search')}
              </Button>
            </Col>
          </Row>
        </Form>
      ) : null}
      <Row justify='end'>
        <Col>
          <Button
            onClick={() => setShowHeader(!showHeader)}
            icon={showHeader ? <UpOutlined /> : <DownOutlined />}
            type='link'
          >
            {showHeader ? 'Hide Filter' : 'Show Filter'}
          </Button>
        </Col>
      </Row>
      <Card>
        <div>
          <Chart dataSource={dataSource?.items} filters={filters} hideContent={hideContent}></Chart>
          <Pagination
            style={{ display: hideContent == true ? 'None' : '' }}
            onChange={(page, pageSize) => {
              setFilters({
                ...filters,
                page: page,
                size: pageSize,
              })
            }}
            defaultCurrent={1}
            total={totalPage}
          ></Pagination>
        </div>
      </Card>
    </Styled>
  )
}
